function getPdpProductData() {
  var el = document.querySelector('[data-product-json]');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    console.error('Failed to parse product JSON:', e);
    return null;
  }
}

function shouldDisableWaitlistSignups(productData) {
  if (!productData) return false;
  if (productData.hideSoldOutOnCollection === true) return true;
  var tags =
    productData.product && Array.isArray(productData.product.tags)
      ? productData.product.tags
      : [];
  return tags.includes('disallow_notify_me') || window.theme.allowBackInStock === false;
}

// Register Interest products (`alternative_notify_me` tag) keep their original
// drawer-based CTA flow and must not be converted into the inline waitlist UI.
function isRegisterInterestProduct(productData) {
  if (!productData || !productData.product) return false;
  var tags = productData.product.tags;
  if (Array.isArray(tags)) {
    return tags.indexOf('alternative_notify_me') !== -1;
  }
  if (typeof tags === 'string') {
    return tags.split(',').map(function (t) { return t.trim(); }).indexOf('alternative_notify_me') !== -1;
  }
  return false;
}

document.addEventListener('DOMContentLoaded', function() {
  const inlineSizeSelector = document.querySelector('[data-inline-size-selector]');
  if (!inlineSizeSelector) return;

  const productForm = document.querySelector('.ProductForm');

  let productData = getPdpProductData();

  function isInStoreOnlyProduct() {
    return (
      productData &&
      productData.product &&
      productData.product.tags &&
      productData.product.tags.includes('availability_instore only')
    );
  }

  function checkCurrentVariantAvailability() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (variantId && productData && productData.variants) {
      const variant = productData.variants.find(v => v.id == variantId);
      if (variant) {
        return variant.available;
      }
    }

    const soldOutText = document.querySelector('.ProductMeta__Inventory');
    if (soldOutText && soldOutText.textContent.toLowerCase().includes('sold out')) {
      return false;
    }

    const addToCartBtn = document.querySelector('.ProductForm__AddToCart');
    if (addToCartBtn) {
      if (addToCartBtn.disabled) {
        return false;
      }
      // Use original button text (before JS changes it) to check availability
      const btnText = (addToCartBtn.dataset.originalText || addToCartBtn.textContent).toLowerCase().trim();
      if (btnText.includes('notify') || btnText.includes('sold out')) {
        return false;
      }
    }

    if (productData && productData.product && !productData.product.available) {
      return false;
    }

    return true;
  }

  inlineSizeSelector.addEventListener('change', function(event) {
    const radio = event.target;
    if (!radio.classList.contains('InlineSizeSelector__Radio')) return;

    const value = radio.getAttribute('data-value');
    const optionPosition = radio.getAttribute('data-option-position');
    const label = radio.nextElementSibling;

    const selectMessage = document.querySelector('.select-message');
    if (selectMessage) {
      selectMessage.style.display = 'none';
    }

    const popoverButton = document.querySelector(
      `.Popover__Value[data-value="${value}"][data-option-position="${optionPosition}"]`
    );

    if (popoverButton) {
      popoverButton.click();
    }

    // When the Popover is inert (alternative_notify_me, disallow_notify_me) popoverButton.click()
    // is swallowed and _onVariantChanged never fires — so the URL doesn't update, Swym can't
    // read the variant for "Add to Saved", and the CTA button state stays wrong.
    // Fire change on the hidden ProductForm__Option radio so theme.js _onOptionChanged runs.
    var optionRadio = document.querySelector(
      '.ProductForm__Option [type="radio"][data-option-position="' + optionPosition + '"][value="' + CSS.escape(value) + '"]'
    );
    // Always dispatch when the popover is inert (alternative_notify_me, disallow_notify_me) because
    // popoverButton.click() is swallowed and the radio may already be checked from the initial render,
    // yet _onOptionChanged was never called to enable the CTA button.
    var popoverIsInert = popoverButton && !!popoverButton.closest('[inert]');
    if (optionRadio && (popoverIsInert || !optionRadio.checked)) {
      optionRadio.checked = true;
      optionRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setTimeout(function() {
      let isUnavailable = false;

      if (popoverButton && popoverButton.classList.contains('unavailable-button')) {
        isUnavailable = true;
      }

      if (label && label.classList.contains('InlineSizeSelector__Label--unavailable')) {
        isUnavailable = true;
      }

      if (!checkCurrentVariantAvailability()) {
        isUnavailable = true;
      }

      toggleWaitlistDisplay(isUnavailable, value);
    }, 150);

    const allLabels = inlineSizeSelector.querySelectorAll('.InlineSizeSelector__Label');
    allLabels.forEach(l => l.classList.remove('is-selected'));
    if (label) {
      label.classList.add('is-selected');
    }
  });

  inlineSizeSelector.addEventListener('click', function(event) {
    const label = event.target.closest('.InlineSizeSelector__Label');
    if (!label) return;

    const radioId = label.getAttribute('for');
    const radio = document.getElementById(radioId);

    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function getWaitlistMainCtaLabel() {
    var tags =
      productData && productData.product && productData.product.tags
        ? productData.product.tags
        : [];
    if (tags.indexOf('alternative_notify_me') !== -1) {
      return (
        (window.languages && window.languages.productFormRegisterInterest) ||
        'Register Interest'
      );
    }
    // Same key as main-product.liquid sold-out CTA: product.form.notify_me
    return (
      (window.languages && window.languages.productFormNotifyMe) ||
      'Join The Waitlist'
    );
  }

  function toggleWaitlistDisplay(showWaitlist, selectedSize) {
    if (isInStoreOnlyProduct()) return;
    // Register Interest products use a drawer modal, not the inline waitlist UI.
    // Leave the button's data-action / label alone so theme.js drawer handling fires.
    if (isRegisterInterestProduct(productData)) return;
    if (productForm) {
      var addToCartBtn = document.querySelector('.ProductForm__AddToCart');
      var waitlistEl = document.querySelector('[data-inline-waitlist]');
      var disableWaitlist = shouldDisableWaitlistSignups(productData);

      if (showWaitlist && !disableWaitlist) {
        productForm.classList.add('ProductForm--showWaitlist');
        // Close inline form when switching variants
        if (waitlistEl) waitlistEl.classList.remove('InlineWaitlist--open');
        var sizeInput = document.querySelector('.InlineWaitlist__SizeValue');
        if (sizeInput) {
          sizeInput.textContent = selectedSize;
        }
        if (addToCartBtn) {
          if (!addToCartBtn.dataset.originalText) {
            addToCartBtn.dataset.originalText = addToCartBtn.textContent.trim();
          }
          if (!addToCartBtn.dataset.originalAction) {
            addToCartBtn.dataset.originalAction = addToCartBtn.getAttribute('data-action') || '';
          }
          addToCartBtn.textContent = getWaitlistMainCtaLabel();
          addToCartBtn.removeAttribute('data-action');
          addToCartBtn.setAttribute('type', 'button');
          addToCartBtn.disabled = false;
        }
      } else {
        productForm.classList.remove('ProductForm--showWaitlist');
        if (waitlistEl) waitlistEl.classList.remove('InlineWaitlist--open');
        if (showWaitlist && disableWaitlist && addToCartBtn) {
          addToCartBtn.textContent =
            (window.languages && window.languages.productFormSoldOut) || 'Sold Out';
          addToCartBtn.removeAttribute('data-action');
          addToCartBtn.setAttribute('type', 'button');
          addToCartBtn.disabled = true;
        }
        // Do not restore button text or attributes here: theme.js _updateAddToCartButton
        // already ran for this variant and sets innerHTML, data-action, type, disabled.
        // Restoring dataset.originalText overwrote that with a stale label (wrong variant / no price).
        if (addToCartBtn) {
          delete addToCartBtn.dataset.originalText;
          delete addToCartBtn.dataset.originalAction;
        }
      }
    }
  }

  function markUnavailableSizes() {
    const unavailableButtons = document.querySelectorAll('.Popover__Value.unavailable-button');
    unavailableButtons.forEach(function(btn) {
      const value = btn.getAttribute('data-value');
      const inlineLabel = inlineSizeSelector.querySelector(
        `.InlineSizeSelector__Label[data-value="${value}"]`
      );
      if (inlineLabel) {
        inlineLabel.classList.add('InlineSizeSelector__Label--unavailable');
      }
    });

    if (productData && productData.variants) {
      productData.variants.forEach(function(variant) {
        if (!variant.available) {
          variant.options.forEach(function(opt) {
            const inlineLabel = inlineSizeSelector.querySelector(
              `.InlineSizeSelector__Label[data-value="${opt}"]`
            );
            if (inlineLabel) {
              inlineLabel.classList.add('InlineSizeSelector__Label--unavailable');
            }
          });
        }
      });
    }
  }

  setTimeout(markUnavailableSizes, 100);

  // For alternative_notify_me products the button starts disabled from Liquid (notOneSize guard).
  // theme.js never calls _updateAddToCartButton on init, so we fire a change on the pre-selected
  // hidden radio after theme.js has finished constructing, which runs _updateAddToCartButton and
  // removes disabled + sets data-action="open-drawer".
  if (isRegisterInterestProduct(productData)) {
    setTimeout(function() {
      var checkedInline = inlineSizeSelector.querySelector('.InlineSizeSelector__Radio:checked');
      if (!checkedInline) return;
      var optionPosition = checkedInline.getAttribute('data-option-position');
      var value = checkedInline.getAttribute('data-value');
      var optionRadio = document.querySelector(
        '.ProductForm__Option [type="radio"][data-option-position="' + optionPosition + '"][value="' + CSS.escape(value) + '"]'
      );
      if (optionRadio) {
        optionRadio.checked = true;
        optionRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 200);
  }



  // theme.js sets disabled on [data-value] elements for disallow_notify_me products,
  // which matches InlineSizeSelector radios too. Re-enable them so users can select a
  // size for Swym "Add to Saved" — visual unavailable styling is handled by CSS alone.
  if (shouldDisableWaitlistSignups(productData)) {
    setTimeout(function() {
      inlineSizeSelector.querySelectorAll('.InlineSizeSelector__Radio[disabled]').forEach(function(r) {
        r.removeAttribute('disabled');
      });
    }, 150);
  }

  function initializeWaitlistDisplay() {
    if (isInStoreOnlyProduct()) return;
    const isCurrentlyUnavailable = !checkCurrentVariantAvailability();

    if (isCurrentlyUnavailable) {
      const selectedRadio = inlineSizeSelector.querySelector('.InlineSizeSelector__Radio:checked');
      const selectedSize = selectedRadio ? selectedRadio.getAttribute('data-value') : '';
      toggleWaitlistDisplay(true, selectedSize);
    }
  }

  setTimeout(initializeWaitlistDisplay, 200);

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        markUnavailableSizes();
      }
    });
  });

  const popoverValueList = document.querySelector('.Popover__ValueList');
  if (popoverValueList) {
    observer.observe(popoverValueList, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }
});

// "Join The Waitlist" button click opens the inline form instead of the drawer
// Placed outside size-selector guard so it works for single-size products too
// Use capture on document to intercept before theme JS delegation.
// Register Interest products (`alternative_notify_me`) intentionally keep the
// drawer-based flow, so we do NOT intercept their clicks here.
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.ProductForm__AddToCart');
  if (!btn) return;
  var pdpProductData = getPdpProductData();
  if (shouldDisableWaitlistSignups(pdpProductData)) return;
  if (isRegisterInterestProduct(pdpProductData)) return;
  var tpl = (btn.getAttribute('data-template') || '');
  if (!tpl.includes('product-notify-me')) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  var productForm = document.querySelector('.ProductForm');
  if (productForm) productForm.classList.add('ProductForm--showWaitlist');
  var waitlistEl = document.querySelector('[data-inline-waitlist]');
  if (waitlistEl) {
    waitlistEl.classList.add('InlineWaitlist--open');
  }
}, true);

document.addEventListener('DOMContentLoaded', function() {
  const waitlistContainer = document.querySelector('[data-inline-waitlist]');
  if (!waitlistContainer) return;

  const waitlistForm = document.querySelector('[data-inline-waitlist-form]');
  if (!waitlistForm) return;

  const emailInput = waitlistForm.querySelector('[data-inline-waitlist-email]');
  const newsletterCheckbox = waitlistForm.querySelector('[data-inline-waitlist-newsletter]');
  const submitButton = waitlistForm.querySelector('[data-inline-waitlist-submit]');
  const buttonText = submitButton?.querySelector('.InlineWaitlist__ButtonText');
  const buttonLoader = submitButton?.querySelector('.InlineWaitlist__ButtonLoader');
  const errorDisplay = waitlistContainer.querySelector('[data-inline-waitlist-error]');
  const successDisplay = waitlistContainer.querySelector('[data-inline-waitlist-success]');

  if (!submitButton) return;

  // Auto-check newsletter when user starts typing email
  // Once the user manually unchecks, stop auto-checking
  if (emailInput && newsletterCheckbox) {
    var userUnchecked = false;

    newsletterCheckbox.addEventListener('change', function() {
      if (!this.checked) {
        userUnchecked = true;
      }
    });

    emailInput.addEventListener('input', function() {
      if (this.value.length > 0 && !newsletterCheckbox.checked && !userUnchecked) {
        newsletterCheckbox.checked = true;
      }
    });
  }

  submitButton.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();

    const email = emailInput.value.trim();
    const newsletter = newsletterCheckbox ? newsletterCheckbox.checked : false;

    if (!email) {
      showError('Please enter your email address.');
      return;
    }

    submitButton.disabled = true;
    if (buttonText) buttonText.style.display = 'none';
    if (buttonLoader) buttonLoader.style.display = 'block';
    hideError();

    const notifyMeButton = document.querySelector('button[data-bis-feed-code]');
    const bisFeedCode = notifyMeButton && notifyMeButton.hasAttribute('data-bis-feed-code')
      ? notifyMeButton.dataset.bisFeedCode
      : null;

    let variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) {
      const pickupAvailability = document.querySelector('pickup-availability');
      if (pickupAvailability) {
        variantId = pickupAvailability.getAttribute('data-variant-id');
      }
    }

    if (!variantId) {
      const selectedOption = document.querySelector('[id^="product-select-"] > [selected="selected"]');
      if (selectedOption) {
        variantId = selectedOption.value;
      }
    }

    if (!variantId) {
      showError('Unable to determine product variant. Please try again.');
      resetButton();
      return;
    }

    function productHasAlternativeNotifyMeTag() {
      var pd = getPdpProductData();
      var p = pd && pd.product;
      if (!p || !p.tags) {
        return false;
      }
      if (Array.isArray(p.tags)) {
        return p.tags.indexOf('alternative_notify_me') !== -1;
      }
      if (typeof p.tags === 'string') {
        return p.tags.split(',').map(function (t) {
          return t.trim();
        }).indexOf('alternative_notify_me') !== -1;
      }
      return false;
    }

    var isRegisterInterestProduct = productHasAlternativeNotifyMeTag();
    var variantRelationshipId =
      isRegisterInterestProduct || !bisFeedCode
        ? '$shopify:::$default:::' + variantId
        : '$custom:::$default:::' + variantId + '-' + bisFeedCode;

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2024-05-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              },
              email: email
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: variantRelationshipId
              }
            }
          }
        }
      })
    };

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyoPublicKey}`, options)
      .then(response => {
        if (response.ok) {
          showSuccess();

          if (newsletter) {
            subscribeToNewsletter(email);
          }
        } else {
          throw new Error('Failed to subscribe');
        }
      })
      .catch(err => {
        console.error('Waitlist subscription error:', err);
        showError('There was an error subscribing. Please try again.');
        resetButton();
      });
  });

  function subscribeToNewsletter(email) {
    const newsLetterOptions = {
      method: "POST",
      headers: {
        revision: "2024-10-15",
        "content-type": "application/vnd.api+json",
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: window.theme.klaviyoNewsLetterId
              }
            }
          },
        }
      })
    };

    fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${window.theme.klaviyoPublicKey}`, newsLetterOptions)
      .catch(err => console.error('Newsletter subscription error:', err));
  }

  function showError(message) {
    if (errorDisplay) {
      errorDisplay.textContent = message;
      errorDisplay.style.display = 'block';
    }
  }

  function hideError() {
    if (errorDisplay) {
      errorDisplay.style.display = 'none';
    }
  }

  function showSuccess() {
    waitlistForm.style.display = 'none';
    if (successDisplay) {
      successDisplay.style.display = 'block';
    }

    // After a few seconds, hide success, reset form, and close inline waitlist
    setTimeout(function() {
      if (successDisplay) {
        successDisplay.style.display = 'none';
      }
      waitlistForm.style.display = '';
      emailInput.value = '';
      if (newsletterCheckbox) newsletterCheckbox.checked = false;
      resetButton();
      // Close the inline form so "Join The Waitlist" button reappears
      if (waitlistContainer) {
        waitlistContainer.classList.remove('InlineWaitlist--open');
      }
    }, 3000);
  }

  function resetButton() {
    submitButton.disabled = false;
    if (buttonText) buttonText.style.display = 'block';
    if (buttonLoader) buttonLoader.style.display = 'none';
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const pageIndicator = document.querySelector('[data-gallery-page-indicator]');
  const pageIndicatorLeft = document.querySelector('[data-gallery-page-indicator-left]');

  if (!pageIndicator && !pageIndicatorLeft) return;

  const currentPageEl = pageIndicator ? pageIndicator.querySelector('[data-current-page]') : null;
  const currentPageLeftEl = pageIndicatorLeft ? pageIndicatorLeft.querySelector('[data-current-page-left]') : null;
  const totalPagesLeftEl = pageIndicatorLeft ? pageIndicatorLeft.querySelector('[data-total-pages-left]') : null;
  const slideshow = document.querySelector('.Product__Slideshow.Carousel');
  if (!currentPageEl && !currentPageLeftEl) return;

  const slideItems = document.querySelectorAll('.Product__SlideItem');
  if (slideItems.length === 0) return;

  if (totalPagesLeftEl) {
    totalPagesLeftEl.textContent = slideItems.length;
  }

  function updateCurrentPage(index) {
    const page = index + 1;
    if (currentPageEl) currentPageEl.textContent = page;
    if (currentPageLeftEl) currentPageLeftEl.textContent = page;
  }

  function isStackedMode() {
    if (!slideshow) return true;
    const computedStyle = window.getComputedStyle(slideshow, '::after');
    const content = computedStyle.getPropertyValue('content');
    return content !== '"flickity"' && content !== "'flickity'";
  }

  function updatePageFromScroll() {
    if (!slideshow) return;

    const scrollTop = slideshow.scrollTop;
    const containerHeight = slideshow.clientHeight;
    let currentIndex = 0;

    slideItems.forEach((slide, index) => {
      const slideTop = slide.offsetTop;
      if (scrollTop >= slideTop - (containerHeight / 2)) {
        currentIndex = index;
      }
    });

    updateCurrentPage(currentIndex);
  }

  function initialize() {
    if (isStackedMode() && slideshow) {
      slideshow.addEventListener('scroll', updatePageFromScroll, { passive: true });
      updatePageFromScroll();
    } else if (slideshow) {
      slideshow.addEventListener('settle.flickity', function() {
        const flkty = Flickity.data(slideshow);
        if (flkty) {
          updateCurrentPage(flkty.selectedIndex);
        }
      });

      slideshow.addEventListener('select.flickity', function() {
        const flkty = Flickity.data(slideshow);
        if (flkty) {
          updateCurrentPage(flkty.selectedIndex);
        }
      });
    }
  }

  initialize();
  window.addEventListener('resize', function() {
    initialize();
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var videos = document.querySelectorAll('video[data-pdp-video]');
  if (!videos.length || typeof IntersectionObserver === 'undefined') return;

  var observer = new IntersectionObserver(
    function(entries) {
      entries.forEach(function(entry) {
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          v.play().catch(function() {});
        } else {
          v.pause();
        }
      });
    },
    {
      threshold: [0, 0.1, 0.2, 0.35, 0.5, 0.65, 0.8, 1],
      rootMargin: '0px'
    }
  );

  videos.forEach(function(v) {
    observer.observe(v);
  });
});
